import React, { useState } from 'react';
import Button from '../@base/Button';
import Modal from '../@base/Modal';
import Scrim from '../@base/Scrim';
import Loading from '../Loading/Loading';

const DeleteConfirmation = (props) => {
  const [isDeleting, setIsDeleting] = useState(false);
  if (isDeleting) return <Loading message="Aguarde..." />;
  return (
    <Scrim classes="is-foco">
      <Modal
        title={props.title}
        content={<p>{props.content}</p>}
        buttons={(
          <>
            <Button
              primary
              small
              classes="mr-1"
              onClick={() => { setIsDeleting(true); props.confirmationClick(); }}
            >
              <small>Sim</small>
            </Button>
            <Button
              primary
              small
              onClick={props.cancelationClick}
            >
              <small>Não</small>

            </Button>
          </>
      )}
      />
    </Scrim>
  );
};

export default DeleteConfirmation;
